<script lang="ts">
	export let width = 24;
	export let height = 24;
</script>

<svg {width} {height} fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M3 4c0-.55.45-1 1-1h2V1H4C2.34 1 1 2.34 1 4v2h2V4ZM3 20v-2H1v2c0 1.66 1.34 3 3 3h2v-2H4c-.55 0-1-.45-1-1ZM20 1h-2v2h2c.55 0 1 .45 1 1v2h2V4c0-1.66-1.34-3-3-3ZM21 20c0 .55-.45 1-1 1h-2v2h2c1.66 0 3-1.34 3-3v-2h-2v2ZM19 14.87V9.13c0-.72-.38-1.38-1-1.73l-5-2.88c-.31-.18-.65-.27-1-.27s-.69.09-1 .27L6 7.39c-.62.36-1 1.02-1 1.74v5.74c0 .72.38 1.38 1 1.73l5 2.88c.31.18.65.27 1 .27s.69-.09 1-.27l5-2.88c.62-.35 1-1.01 1-1.73Zm-8 2.3-4-2.3v-4.63l4 2.33v4.6Zm1-6.33L8.04 8.53 12 6.25l3.96 2.28L12 10.84Zm5 4.03-4 2.3v-4.6l4-2.33v4.63Z"
		fill="currentColor"
	/>
</svg>
